module.exports = __webpack_public_path__ + "img/bank-note-01.fac63ea6.svg";